import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import * as initialSelectors from './selectors';
import type { ICustomersContextValue } from './types';

export default createContext<ICustomersContextValue>({
  state: initialState,
  actions: initialActionsState,
  selectors: initialSelectors,
});
